import { render, staticRenderFns } from "./ShiftManager.vue?vue&type=template&id=0d356d14&"
import script from "./ShiftManager.vue?vue&type=script&lang=js&"
export * from "./ShiftManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports